package com.tixforgigs.common.core.extensions

import com.tixforgigs.apax.infrastructure.HttpResponse
import com.tixforgigs.apax.models.ApiError
import com.tixforgigs.apax.models.Headers
import com.tixforgigs.common.core.util.PagingUtil.PagingRequest

fun ApiError.toThrowable() = Throwable(
  message = "Tix API Error (HTTP Status $status): $title - $detail // ${
    properties?.toList()?.joinToString { "${it.first}: ${it.second}" }
  }"
)

fun <T : Any, R : PagingRequest<R>> HttpResponse<T>.hasMoreItems(request: R): Boolean {
  return headers[Headers.RESULTS_TOTAL.value]?.firstOrNull()?.toIntOrNull()?.let { total ->
    if (total < request.itemSize) false
    else total > request.itemSize * request.page
  }.orElse {
    false
  }
}
